import { OFFLINE_MODE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function PatchOfflineMode(code, data){
    const api = `${OFFLINE_MODE_API}${code}/`;
    return axiosHttp.patch(api, data);
}